// extracted by mini-css-extract-plugin
export default {"root":"user-groups_root__p3hbf","item":"user-groups_item__8xPMm"};